import { useState } from 'react';

import {
    // Box,
    Link
} from '@mui/material';

import { documentTypes } from './useDocuments';

export const formikDependencyStateField = 'dependencies'

export const dependencyTypes = {
    reference: "reference"
}
export const targetTypes = {
    document: "document",
}

export const dependencyModules = {
    document: {
        ...documentTypes
    }
}

export const dependencyRefs = {
    document: 'document',
    documentItem: 'document_item'
}


export const dependencyRelations = {
    reference: `reference`,
    bind: `bind`
}

export function useDependencies() {

    const getDependencyItem = ({
        targetType,
        dependencyModule,
        dependencyRef,
        relation,
        targetId = ''
    }) => {
        return {
            target: targetType,
            module: dependencyModule,
            dependency_ref: dependencyRef,
            target_id: targetId,
            type: relation
        }
    }

    const getViewUrl = ({ target, targetId, module }) => {
        let url = '';

        if (target === targetTypes.document) {

            let name = ''

            if (module.toLowerCase() === dependencyModules.document.salesOrder.toLowerCase()) name = `salesOrder`
            if (module.toLowerCase() === dependencyModules.document.deliveryOrder.toLowerCase()) name = `deliveryOrder`
            if (module.toLowerCase() === dependencyModules.document.salesInvoice.toLowerCase()) name = `salesInvoice`
            if (module.toLowerCase() === dependencyModules.document.cashSales.toLowerCase()) name = `cashSales`
            if (module.toLowerCase() === dependencyModules.document.retailCashSales.toLowerCase()) name = `retailCashSales`
            if (module.toLowerCase() === dependencyModules.document.salesDebitNote.toLowerCase()) name = `salesDebitNote`
            if (module.toLowerCase() === dependencyModules.document.salesCreditNote.toLowerCase()) name = `salesCreditNote`
            if (module.toLowerCase() === dependencyModules.document.replacementDelivery.toLowerCase()) name = `replacementDelivery`

            if (module.toLowerCase() === dependencyModules.document.purchaseOrder.toLowerCase()) name = `purchaseOrder`
            if (module.toLowerCase() === dependencyModules.document.purchaseReturn.toLowerCase()) name = `purchaseReturn`
            if (module.toLowerCase() === dependencyModules.document.purchaseInvoice.toLowerCase()) name = `purchaseInvoice`

            if (module.toLowerCase() === dependencyModules.document.itemReceive.toLowerCase()) name = `itemReceive`
            if (module.toLowerCase() === dependencyModules.document.itemTransfer.toLowerCase()) name = `itemTransfer`
            if (module.toLowerCase() === dependencyModules.document.itemRelocate.toLowerCase()) name = `itemRelocate`
            if (module.toLowerCase() === dependencyModules.document.itemTransform.toLowerCase()) name = `itemTransform`
            if (module.toLowerCase() === dependencyModules.document.itemIssue.toLowerCase()) name = `itemIssue`
            if (module.toLowerCase() === dependencyModules.document.itemAdjustment.toLowerCase()) name = `itemAdjustment`
            if (module.toLowerCase() === dependencyModules.document.stockTake.toLowerCase()) name = `stockTake`
            if (module.toLowerCase() === dependencyModules.document.transferReturn.toLowerCase()) name = `transferReturn`
            if (module.toLowerCase() === dependencyModules.document.transferRequisition.toLowerCase()) name = `transferRequisition`

            url = `documents/${name}/view/${targetId}`

        }

        return (url)
    }

    const RenderDatagridDisplay = ({
        id,
        values = [],
        renderValue = () => {}
    }) => {

        const { url, display } = getDatagridDisplay({ id, values, renderValue })

        if(display === ""){
            return "-"
        }

        return (
            <Link
                href={url}
                target="_blank"
            >
                {display}
            </Link>
        )

    }

    const getDatagridDisplay = ({
        id,
        values = [],
        renderValue = () => {}
    }) => {

        let valueDocumentNumber = ""
        let valueTargetId = ""
        let valueTarget = ""
        let valueModule = "";

        let url = ``
        let display = ``

        // no values
        if(values.length === 0){
            url = ``
            display = ``
        }else if(values.length === 1){ // have only one document

            valueDocumentNumber = values[0].document_number
            valueTargetId = values[0].document_id
            valueModule = values[0]?.module
            valueTarget = values[0]?.target

            let otherUrl = getViewUrl({ target: valueTarget, targetId: valueTargetId, module: valueModule })
            url = renderValue({ otherUrl })

            display = valueDocumentNumber

        }else{ // multiple
            url = renderValue({ id })
            display = `${values.length} Documents`
        }

        return {
            url,
            display
        }

    }

    // const updateFormikDependencyStates = () => ({
    //     setFieldValue,
    //     array
    // }) => {
    //     setFieldValue(`${formikDependencyStateField}`, array)
    // }


    // const getFormikDependencyStates = ({
    //     values
    // }) => {
    //     return values[`${formikDependencyStateField}`]
    // }

    return {
        getDependencyItem,
        getViewUrl,
        getDatagridDisplay,
        RenderDatagridDisplay,
        // updateFormikDependencyStates,
        // getFormikDependencyStates
    }
}